import axios from 'axios'
import * as config from 'config'

const topics = () => axios.get(`${config.apiUrl}faq/topicos`)

export { topics }
